import { useEffect, useState } from 'react';

// Stadium video-board screens (e.g. 796x448, 1148x448) and phones in landscape
// are wide but very short - switch to a tighter, single-viewport layout below this height.
const QUERY = '(max-height: 560px)';

const useCompactLayout = ():boolean => {
  const [isCompact, setIsCompact] = useState<boolean>(() => window.matchMedia(QUERY).matches);

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const handler = (e:MediaQueryListEvent) => setIsCompact(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isCompact;
}

export default useCompactLayout;
